/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { pushOneBlog } from "../../../../middlewares/sysNavigation/SysNavigation";
import { useBlogContext } from "../../../../context/blog/BlogContext";
import { Search, Button, Pagination } from "../../component/Component";
import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";
import {
  FiFileText,
  FiUser,
  FiHash,
  FiTrash2,
  FiCheck,
  FiX,
  FiInfo,
  FiTag,
} from "react-icons/fi";

const addRoute = "/blog/add";
const editRoute = "/blog/edit";

const Overview = () => {
  const { blogs, fetchBlogs, count } = useBlogContext();
  const [blogsList, setBlogList] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  useEffect(() => {
    if (!blogs) fetchBlogs(page, pageSize);
    else setBlogList(blogs);
  }, [blogs]);

  const SearchList = (e) => {
    const key = e.target.value.toLowerCase();
    if (!blogs) return;
    const filtered = blogs.filter((b) =>
      String(b.title).toLowerCase().includes(key)
    );
    setBlogList(key ? filtered : blogs);
  };

  return (
    <div className="h-full overflow-y-auto rounded-b-xl bg-gradient-to-b from-white to-gray-50 p-4 lg:p-6">
      <div className="mx-auto max-w-6xl space-y-5">
        <div className="rounded-3xl border border-gray-200 bg-white shadow-sm">
          <div className="flex flex-col gap-3 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
            <div className="flex items-center gap-3">
              <span className="grid h-10 w-10 place-items-center rounded-xl bg-gray-900 text-white">
                <FiFileText className="h-5 w-5" />
              </span>
              <div>
                <div className="text-sm font-semibold tracking-tight text-gray-900">
                  Blog Manager
                </div>
                <div className="mt-1 flex flex-wrap items-center gap-2 text-[11px]">
                  <span className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-gray-100 px-2.5 py-1 text-gray-700">
                    <FiTag className="h-3.5 w-3.5" />
                    {blogsList?.length ? blogsList.length.toLocaleString() : 0} results
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-emerald-700">
                    <FiInfo className="h-3.5 w-3.5" />
                    Edit content or delete posts
                  </span>
                </div>
              </div>
            </div>
            <div className="flex w-full items-center gap-3 sm:w-auto">
              <div className="w-full sm:w-80">
                <Search
                  props={{
                    title: "Search blogs…",
                    onChange: (e) => SearchList(e),
                  }}
                />
              </div>
              <Link to={addRoute} className="shrink-0">
                <Button
                  props={{
                    type: "button",
                    title: (
                      <span className="inline-flex items-center gap-2">
                        {/* <FiPlus className="h-4 w-4" /> */}
                        Add Blog
                      </span>
                    ),
                    category: "default",
                    action: "add",
                    onClick: null,
                  }}
                />
              </Link>
            </div>
          </div>
        </div>

        <div className="rounded-3xl border border-gray-200 bg-white shadow-sm">
          <div className="relative max-h-[65vh] overflow-auto rounded-3xl">
            <table className="min-w-full table-fixed text-sm">
              <thead className="sticky top-0 z-10 bg-white/90 backdrop-blur">
                <tr className="text-left text-xs uppercase tracking-wide text-gray-500">
                  <th className="w-[36%] px-4 py-3 font-semibold">
                    <span className="inline-flex items-center gap-2">
                      <FiFileText className="h-4 w-4" />
                      Title
                    </span>
                  </th>
                  <th className="w-[28%] px-4 py-3 font-semibold">
                    <span className="inline-flex items-center gap-2">
                      <FiHash className="h-4 w-4" />
                      Slug
                    </span>
                  </th>
                  <th className="w-[28%] px-4 py-3 font-semibold">
                    <span className="inline-flex items-center gap-2">
                      <FiUser className="h-4 w-4" />
                      Author
                    </span>
                  </th>
                  <th className="px-4 py-3 text-center font-semibold">Action</th>
                </tr>
              </thead>
              <tbody>
                {blogsList && blogsList.length > 0 ? (
                  blogsList.map((b) => (
                    <tr
                      key={b.blog_id}
                      className="border-t border-gray-100 hover:bg-gray-50/70"
                    >
                      <td className="px-4 py-3 align-middle">
                        <div className="flex items-center gap-3">
                          <span className="grid h-8 w-8 place-items-center rounded-lg bg-gray-900 text-[10px] font-bold text-white">
                            {String(b.title).slice(0, 2).toUpperCase()}
                          </span>
                          <div className="truncate font-semibold text-gray-900">
                            {b.title}
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-3 align-middle">
                        <span className="inline-flex items-center gap-2 rounded-lg bg-gray-100 px-2.5 py-1 text-[11px] font-semibold text-gray-700 ring-1 ring-gray-200">
                          <FiHash className="h-3.5 w-3.5" />
                          {String(b.slug).slice(0, 30)}
                        </span>
                      </td>
                      <td className="px-4 py-3 align-middle">
                        <div className="inline-flex items-center gap-2 text-gray-800">
                          <FiUser className="h-4 w-4 text-gray-500" />
                          <span className="truncate">{b.author}</span>
                        </div>
                      </td>
                      <td className="px-4 py-3 align-middle">
                        <div className="flex items-center justify-center">
                          <ActionButton blogData={b} />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="px-4 py-6 text-center text-gray-500" colSpan={4}>
                      No blogs found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="border-t border-gray-100 px-4 py-3">
            <Pagination
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              total_items={count}
              callbackFunction={(p, s) => fetchBlogs(p, s)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const ActionButton = ({ blogData }) => {
  const { blogs, setBlog, deleteBlog, updateBlogState } = useBlogContext();
  const [show, setShow] = useState(false);

  const remove = async () => {
    const response = await deleteBlog(blogData.blog_id);
    if (response?.data?.status === 200) {
      const update = (blogs || []).filter((x) => x.blog_id !== blogData.blog_id);
      updateBlogState(update);
      setShow(false);
    }
  };

  return (
    <>
      <div className="inline-flex items-center gap-3">
        <Link to={editRoute}>
          <Button
            props={{
              type: "button",
              title: (
                <span className="inline-flex items-center gap-2">
                  {/* <FiEdit2 className="h-4 w-4" /> */}
                  Edit
                </span>
              ),
              category: "blue",
              action: "edit",
              onClick: () => {
                pushOneBlog(blogData);
                setBlog(null);
              },
            }}
          />
        </Link>
        <Button
          props={{
            type: "button",
            title: (
              <span className="inline-flex items-center gap-2">
                {/* <FiTrash2 className="h-4 w-4" /> */}
                Delete
              </span>
            ),
            category: "red",
            action: "delete",
            onClick: () => setShow(true),
          }}
        />
      </div>

      <ConfirmModal
        open={show}
        title="Delete this blog post?"
        description={`“${blogData.title}” will be permanently removed.`}
        onCancel={() => setShow(false)}
        onConfirm={remove}
        confirmText="Delete"
      />
    </>
  );
};

const ConfirmModal = ({
  open,
  title,
  description,
  onCancel,
  onConfirm,
  confirmText = "Proceed",
}) => {
  if (!open) return null;
  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-title"
      aria-describedby="confirm-desc"
      className="fixed inset-0 z-[2147483647] isolate flex items-center justify-center p-4"
    >
      <div className="absolute inset-0 bg-black/70 backdrop-blur-[2px]" onClick={onCancel} />
      <div className="relative w-full max-w-md rounded-2xl border border-gray-200 bg-white/95 shadow-2xl ring-1 ring-black/5 supports-[backdrop-filter]:bg-white/85">
        <div className="absolute inset-x-0 top-0 h-1 rounded-t-2xl" />
        <div className="relative px-5 pt-5">
          <div className="flex items-start gap-3">
            <span className="grid h-9 w-9 place-items-center rounded-lg bg-rose-100 text-rose-700">
              <FiTrash2 className="h-5 w-5" />
            </span>
            <div>
              <h3 id="confirm-title" className="text-base font-semibold text-gray-900">
                {title}
              </h3>
              {description ? (
                <p id="confirm-desc" className="mt-1 text-sm text-gray-600">
                  {description}
                </p>
              ) : null}
            </div>
          </div>
        </div>
        <div className="px-5 pb-5 pt-4 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-500"
          >
            <FiX className="h-4 w-4" />
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="inline-flex items-center gap-2 rounded-lg bg-rose-600 px-3 py-2 text-xs font-semibold text-white shadow hover:bg-rose-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-500"
          >
            <FiCheck className="h-4 w-4" />
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Overview;
